import React from "react";

import "./css/layoutStyle.css";
import "./css/mobileStyle.css";
import { useNavigate } from "react-router-dom";

const SignUpConfirmation = () => {
  const navigate = useNavigate();
  const handleNavigateTo = (path) => { navigate(path); };

  // ***************
  // ** Functions **
  // ***************
  const handleRedirectButton = () => {
    handleNavigateTo("/loginGroup");
  };

	// ************
	// ** Return **
	// ************
	return (
		<div id="mainContainerSignUp">
      <div id="secondaryContainerSignUp">

        {/* 
          *******************
          ** SVG Animation **
          *******************
        */}
        <section id="svgAnimationSection">
          <iframe id="svgContainer" title="Pagamento aceito com sucesso" src="https://embed.lottiefiles.com/animation/16271"></iframe>
        </section>


        {/* 
          ************************
          ** Message and Button **
          ************************
        */}
        <section id="messageButtonSection">
          <span id="messageSpan">Compra efetuada com sucesso! Verifique seu email para receber seu login e senha da aplicação.</span>
          <span id="buttonSpan" onClick={handleRedirectButton}>Ir ao Painel</span>
        </section>
      </div>
    </div>
	);
};

export default SignUpConfirmation;